import React, { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../../AnimatedLetters'
import './index.scss'

const TraineeProjectManager = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="col s12 center-align">
          <h1 className={letterClass}>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={[
                'H',
                'i',
                '-',
                'T',
                'e',
                'c',
                'h',
                ' ',
                'P',
                'l',
                'u',
                's',
              ]}
              idx={15}
            />
          </h1>
        </div>

        <h3 className="experience-title">
          Trainee Project Manager - Internship
        </h3>

        {/* Project Containers */}
        <div className="row project-container-wrapper">
          <div className="col s12 m6 project-container-1">
            <h4>• Project Documentation & Presentation Skills</h4>
            <p>
              - Produced comprehensive, client-focused presentations using
              project management methodologies.
            </p>
            <p>
              - Created detailed project documentation, including project
              charters, timelines, and reports, ensuring that all materials were
              delivered promptly for client meetings.
            </p>
            <p>
              - Utilised Gantt charts to visually represent project timelines,
              helping to ensure clarity in communication with stakeholders and
              teams during the course of each project.
            </p>
          </div>

          <div className="col s12 m6 project-container-2">
            <h4>• Task Management with Trello</h4>
            <p>
              - Used Trello to organise and assign project tasks efficiently,
              creating structured boards divided into sections like 'to-do',
              'in-progress', and 'completed'.
            </p>
            <p>
              - Monitored task progress and provided regular updates to the team
              using Trello's collaborative features, ensuring that deadlines
              were met.
            </p>
            <p>
              - Incorporated visual task management tools such as matrices and
              Gantt charts to streamline tracking and provide a clear overview
              of project status.
            </p>
          </div>

          <div className="col s12 m6 project-container-3">
            <h4>• Development of Project Artefacts</h4>
            <p>
              - Developed essential project artefacts such as risk assessment
              matrices, communication plans, and task lists, ensuring all
              documents aligned with client objectives and project goals.
            </p>
            <p>
              - Assisted in the creation of weekly status reports and
              stakeholder communication documents to ensure transparency in
              project progression.
            </p>
            <p>
              - Ensured that all project artefacts followed structured
              methodologies, contributing to successful project delivery.
            </p>
          </div>

          <div className="col s12 m6 project-container-4">
            <h4>• Proactive Problem-Solving & Stakeholder Communication</h4>
            <p>
              - Demonstrated initiative by suggesting improvements in task
              prioritisation and resource allocation, enabling the team to
              manage workloads effectively.
            </p>
            <p>
              - Maintained clear lines of communication with stakeholders by
              producing weekly progress reports and providing timely updates on
              risks or potential issues.
            </p>
            <p>
              - Actively sought feedback from the team and stakeholders to
              ensure alignment on project goals and milestones, using data from
              Trello and other tools to inform decision-making.
            </p>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default TraineeProjectManager
